import { FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query'
import moment from 'moment'
import { api } from './BaseApi'
import {
  ICurrentWeight,
  IOrder,
  IOrdersResponseDto,
  OrderType,
  StatusOrder,
  IResponseModel,
  IRequestTrainModel,
} from './dto/OrderObjDto'

export enum OrderingByDate {
  ORDER_DATE_START = 'order_date_start',
  ORDER_DATE_START_TIME = 'order_date_start__time',
  ORDER_CREATED_DATE = 'order_date',
}

export const orderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllOrdersBuffet: builder.query<IOrdersResponseDto, null>({
      query: () => ({
        url: `/order/get_simple_orders/`,
        params: {
          status: `${StatusOrder.Created},${StatusOrder.Working}`,
          order_type: OrderType.Buffet,
          order_current_datetime: moment().format(),
          ordering: OrderingByDate.ORDER_DATE_START_TIME,
          archived: '0',
        },
      }),
      transformResponse: (
        response: IOrdersResponseDto,
        meta: FetchBaseQueryMeta,
        _: any,
      ) => {
        return { ...response, results: response.results.slice(0, 2) }
      },
      providesTags: ['Order', 'PlanMenu'],
    }),
    getOrderById: builder.query<IOrder, string>({
      query: (id) => ({
        url: `/order/${id}/`,
      }),
      providesTags: ['Order'],
    }),
    getCurrentWeight: builder.query<ICurrentWeight, null | void>({
      query: () => ({
        url: `/order/get_weight/now/`,
      }),
      providesTags: ['Order'],
      keepUnusedDataFor: 0,
    }),
    trainModel: builder.mutation<IResponseModel, IRequestTrainModel>({
      query: (item) => ({
        url: `/ai/train_model/`,
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['TrainingAiProcess'],
    }),
    checkLatestModel: builder.query<IResponseModel, void>({
      query: (item) => ({
        url: `/ai/check_latest_model/`,
        method: 'GET',
      }),
    }),
    enableLatestModel: builder.mutation<IResponseModel, void>({
      query: () => ({
        url: `/ai/set_latest_model/`,
        method: 'POST',
      }),
    }),
    checkTrainingProcess: builder.query<IResponseModel, void>({
      query: (item) => ({
        url: `/ai/check_training_process/`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useTrainModelMutation,
  useCheckTrainingProcessQuery,
  useLazyCheckLatestModelQuery,
  useEnableLatestModelMutation,
  useGetOrderByIdQuery,
  useGetCurrentWeightQuery,
  useGetAllOrdersBuffetQuery,
} = orderApi
